export const dummyDataNewestAnimals = {
  petInListInShelterDto: [
    {
      petId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      name: "TEST1",
      animalCategory: "Cat",
      gender: "Male",
      species: "Persian",
      marking: "White",
      weight: 14,
      photos: [
        "https://hips.hearstapps.com/hmg-prod/images/domestic-cat-lies-in-a-basket-with-a-knitted-royalty-free-image-1592337336.jpg?crop=0.668xw:1.00xh;0.247xw,0&resize=1200:*",
        "https://icatcare.org/app/uploads/2018/07/Thinking-of-getting-a-cat.png",
      ],
      months: 2,
      createdAt: "2023-07-31T21:46:59.855Z",
      isSterilized: true,
      isVisible: true,
      description: "Animal is a lovely Persian cat looking for a forever home.",
      views: 150,
    },
    {
      id: "3fa85f66-5717-4562-b3fc-2c963f66afa63",
      name: "Maniek",
      animalCategory: "Dog",
      gender: "Male",
      species: "Persian",
      marking: "White",
      weight: 5.2,
      profilePhoto:
        "https://hips.hearstapps.com/hmg-prod/images/large-cat-breed-1553197454.jpg",
      photos: [
        "https://www.lismore.nsw.gov.au/files/assets/public/1.-households/3.-pets-amp-animals/images/kitten.jpg?dimension=pageimage&w=480",
        "https://images.unsplash.com/photo-1615807713086-bfc4975801d0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2F0JTIwZmFjZXxlbnwwfHwwfHx8MA%3D%3D&w=1000&q=80",
      ],
      age: 2,
      createdAt: "2023-07-31T21:46:59.855Z",
      isSterilized: true,
      isVisible: true,
      description: "Animal is a lovely Persian cat looking for a forever home.",
      views: 141,
    },
    {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa7",
      petIdentifier: "XYZ789",
      name: "TEST3",
      animalCategory: "Other",
      gender: "Male",
      species: "Golden Retriever",
      marking: "Golden",
      weight: 27.5,
      profilePhoto:
        "https://ichef.bbci.co.uk/news/976/cpsprodpb/9802/production/_93741983_3cd04e7a-f975-4ccc-ad63-1e805136120b.jpg",
      photos: [
        "https://repository-images.githubusercontent.com/347290041/a27b1400-9c94-11eb-96cf-d442ac64dc87",
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSTrbsrZspV4xwKtX8aNnhw41cv8suyesUNA&usqp=CAU",
      ],
      age: 3,
      createdAt: "2023-07-31T22:15:12.123Z",
      isSterilized: true,
      isVisible: true,
      description:
        "Animal is a friendly and playful Golden Retriever looking for an active family.",
      views: 148,
    },
  ],
  totalPages: 1,
  totalItemsCount: 3,
};
